import React, { useRef, useState, useEffect } from 'react';

function MenuDropDown({ activator, children, active = false }) {
  const [showChildren, setShowChildren] = useState(false);

  let menuRef = useRef();

  useEffect(() => {
    let handler = (event) => {
      if (!menuRef.current?.contains(event.target)) {
        setTimeout(() => {
          setShowChildren(false);
        }, 100);
      }
    };
    document.addEventListener('mousedown', handler);

    return () => {
      document.removeEventListener('mousedown', handler);
    };
  });

  const onClick = () => {
    setShowChildren((isShow) => !isShow);
  };

  return (
    <div style={{ width: 'fit-content' }} ref={menuRef} onClick={onClick}>
      {activator}
      {showChildren && children}
    </div>
  );
}

export default MenuDropDown;
